import React from 'react';
import { useState } from 'react';
import copy from 'copy-to-clipboard';
import {
  IconCopyLine,
  IconCheckLine,
  IconButton,
  View,
} from '@smarterservices/smarter-ui';
const CopyValue = (props) => {
  const [copied, setCopied] = useState(false);

  /**
   * Copies the provided text to the clipboard and temporarily sets the
   * copied state to true, indicating that the copy action was successful.
   * The copied state is reverted back to false after 1 second.
   *
   * @param {Object} props - The properties object.
   * @param {string} props.text - The text to be copied to the clipboard.
   */

  const handleCopy = (props) => {
    copy(props.text);

    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 1000);
  };
  return (
    <View margin={props.margin ? props.margin : 'none'}>
      {!copied ? (
        <IconButton
          onClick={handleCopy}
          size="small"
          themeOverride={{
            borderWidth: 0,
          }}
          screenReaderLabel="Copy Value"
        >
          <IconCopyLine />
        </IconButton>
      ) : (
        <IconButton
          size="small"
          themeOverride={{
            borderWidth: 0,
          }}
          screenReaderLabel="Value Copied"
        >
          <IconCheckLine color="success" />
        </IconButton>
      )}
    </View>
  );
};

export default CopyValue;
